module.exports = __webpack_public_path__ + "img/fb.73b20340.svg";